import Vue from 'vue';

import './assets/scss/app.scss';
import 'swiper/css/swiper.css';


import router from './router';
import App from './App.vue';
import store from './store';
// metaタグ
import VueMeta from 'vue-meta';
// rellax.js
// import VueRellaxEsm from 'vue-rellax';
// lax.js
import lax from 'lax.js';
// Velocity.js
// import Velocity from 'velocity-animate';
// Swiper.js
import VueAwesomeSwiper from 'vue-awesome-swiper';
// Google Recaptcha
import {VueReCaptcha} from 'vue-recaptcha-v3';

// Vue.config.devtools = true;

/*
 * js読み込み時に起動走る。
 * 認証チェック
 */
store.dispatch('auth/check');


// js読み込み時に起動走る。
router.beforeEach((to, from, next) => {
	
	store.commit('page/name', to.name);
	next();
});

/**
 * Vue-Meta
 */
Vue.use(VueMeta);
/**
 * Vue.use(VueRellaxEsm)
 */
Vue.use(VueAwesomeSwiper);
/**
 * lax.js
 * */
Vue.prototype.$lax = lax;
/**
 * Gogle Recaptcha V3
 */
/*
Vue.use(VueReCaptcha, {
	siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
	loaderOptions: {
		explicitRenderParameters: {
			autoHideBadge: true,
			badge: 'bottomright',
			size: 'invisible',
		}
	}
});
 */


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
